module.exports = __webpack_public_path__ + "static/media/13.0ce5cb24.png";